import React, {Component} from 'react';
import Header from './Shared/Header';

class SFHeader extends Component {
    render() {
        return (
            <Header topHeader={this.props.sliders[0]} newClassName={"product-index-visual"} />
        )
    }
}

export default SFHeader;